import {
  Service
} from '../../../service.js'
import {
  env
} from '../../../env.js'

import { toastUtils } from '../../../util/toast.utils.js';
import { ToastBuilder, toastTypeEnum } from '../../../builder/toast.builder.js';

class HistoricoTarefasService extends Service {
  constructor(controladoresDeInstancia) {
    super(controladoresDeInstancia);

    this.controladoresDeInstancia = {
      ...this.controladoresDeInstancia,
      paralisar: new AbortController(),
      continuar: new AbortController(),
      exportarPlanilha: new AbortController()
    }

    this.url = env.url + "historico-tarefas";
  }

  async concluir(historicoTarefaId, faseId, motivoBaixa) {
    try {
      const response = await super.post(this.url + `/baixar`, {
        faseId,
        historicoTarefaId,
        motivoBaixa
      });

      if (response.status === 200) {
        toastUtils.successToast(`${!!faseId? "Fase" : "Tarefa"} concluída com sucesso!`);
        return true;
      }

      const responseJson = await response.json();
      const errorMessage = !!responseJson?.message? responseJson : {message: "Ocorreu um erro durante a conclusão. Por favor contate nosso suporte para mais informações."}
      throw errorMessage

    } catch (e) {
      toastUtils.dangerToast(e.message)
      return false;
    }
  }

  async concluirManualmenteDashboardDoCliente(historicoTarefaId, motivoBaixa) {
    try {
      const response = await super.post(this.url + `/baixar-dashboard-cliente`, {
        historicoTarefaId,
        motivoBaixa,
      });

      if (response.status === 200) {
        toastUtils.successToast("Tarefa concluída com sucesso!");
        return true;
      } else {
        toastUtils.dangerToast("Ocorreu um erro durante a conclusão. Por favor contate nosso suporte para mais informações.")
      }

    } catch {
      toastUtils.dangerToast("Ocorreu um erro durante a conclusão. Por favor contate nosso suporte para mais informações.")
      return false;
    }
  }

  async reabrir(historicoTarefaId, faseId, motivoReabertura, isReabrirFasesPosteriores) {
    try {
      const response = await super.post(this.url + `/reabrir`, {
        faseId,
        historicoTarefaId,
        motivoReabertura,
        isReabrirFasesPosteriores

      });

      var mensagemToast = isReabrirFasesPosteriores ? "Tarefas reabertas com sucesso!" : "Tarefa reaberta com sucesso!";
      if (response.status === 200) {
        toastUtils.successToast(mensagemToast);
        return true;
      } else {
        toastUtils.dangerToast("Ocorreu um erro durante a reabertura da tarefa. Por favor contate nosso suporte para mais informações.")
      }

    } catch {
      toastUtils.dangerToast("Ocorreu um erro durante a reabertura da tarefa. Por favor contate nosso suporte para mais informações.")
      return false;
    }
  }

  async listarHistorico(objetoDeFiltros, removerPagina = false) {
    if(removerPagina) {
      delete objetoDeFiltros.pagina;
    }
    const queryString = this.converterObjetoDeFiltrosParaURIEncodedString(objetoDeFiltros);
    return super.get(this.url + queryString);
  }

  async listarSemPermissao() {
    return super.get(this.url + "/sem-permissao");
  }

  async delete(item) {
    return await super.delete(this.url, item);
  }

  async post(item) {
    const response = await super.post(this.url, item);
    if (response.status === 201) {
      toastUtils.successToast("Tarefa cadastrada com sucesso!");
      setTimeout(() => {
        window.location.reload(true);
      }, 3000);
    } else {
      throw new Error("HTTP " + response.status);
    }
  }

  async editarAvulsa(item, isModeloImportado) {
    item.isModeloImportado = isModeloImportado;
    const response = await super.patch(`${this.url}/editar-avulsa`, item);
    if (response.status === 200 || response.status === 201 || response.ok) {
      toastUtils.successToast("Tarefa editada com sucesso!");
    } else {
      throw new Error("HTTP " + response.status);
    }
  }

  async baixarMultiplas(ids = [], motivoBaixa = "") {
    try {
      const url = `${this.url}/baixar-multiplas`;
      const objPost = {
        ids,
        motivoBaixa
      }
      const response = await super.post(url, objPost);

      if (response.status === 201 || response.status === 200) {
        toastUtils.successToast("Tarefa(s) concluída(s) com sucesso!");
      }

      await this.showBaixaMultiplaErrors(response);
      return response;
    } catch (e) {
      const message = e.name == "TypeError"? "Ocorreu um erro durante a conclusão. Por favor contate nosso suporte para mais informações." : e.message
      toastUtils.dangerToast(message)
      return false;
    }
  }

  async showBaixaMultiplaErrors(response) {
    const responseJson = await response.json();
    if (!Array.isArray(responseJson) || responseJson.length == 0) return;
    for (let i = 0; i < responseJson.length; i++) {
      new ToastBuilder()
        .setType(toastTypeEnum.DANGER)
        .setDuration(8000)
        .setMessage(responseJson[i])
        .toast();
    }    
  }

  async excluirMultiplas(ids = [], motivoExclusao = "") {
    const url = `${this.url}/excluir-multiplas`;
    const objPost = {
      ids,
      motivoExclusao
    }

    const response = await super.post(url, objPost);
    
    if (response.status === 201 || response.status === 200) {
      toastUtils.successToast("Tarefa(s) excluída(s) com sucesso!");
      return response;
    } else {
      toastUtils.dangerToast("Não foi possível excluir as tarefas!");
      throw new Error("HTTP " + response.status);
    }
  }

  async transferirResponsavelEDepartamento(historicosId = [], usuarioId, departamentoId, fasesId, isTransferenciaIndividual) {
    const url = `${this.url}/transferir-departamento-responsavel`;
    const objPost = {
      historicosId,
      usuarioId,
      fasesId,
      departamentoId,
      isTransferenciaIndividual
    }

    const response = await super.post(url, objPost);
    
    if (response.status === 201 || response.status === 200 && !isTransferenciaIndividual) {
      toastUtils.successToast("Tarefa(s) transferida(s) com sucesso!");
      return response;
    } else if (response.status === 201 || response.status === 200 && isTransferenciaIndividual) {
      toastUtils.successToast("Tarefa transferida com sucesso!");
      return response;
    } else {
      toastUtils.dangerToast("Não foi possível transferir a(s) tarefa(s)!");
      throw new Error("HTTP " + response.status);
    }
  }

  async editarVencimentoTarefaAvulsa(id, prazoEntrega) {
    const url = `${this.url}/editar-prazo`;

    const obj = {
      id,
      prazoEntrega
    }

    const response = await super.patch(url, obj);
    const messageResponse = await response.json();
    const message = messageResponse.message;

    if (response.status === 200) {
      toastUtils.successToast(message);
      return response;
    } else if (response.status == 400) {
      toastUtils.dangerToast(message);
      throw new Error('HTTP ' + response.status);
    } else {
      toastUtils.dangerToast("Prazo de entrega inválido!");
      throw new Error('HTTP ' + response.status)
    }
  }

  //TODO: Implementar services segragados na ECT-79;
  //services de departamentos e departamentos padrão foram segredados e
  //foi criado um útil para retornar os dois concatenados no formato utilizado
  //pelo front;
  
  async listarDepartamentos() {
    let url = `${env.baseDocumento}departamentos-do-bureau?page[offset]=0`;
    return super.buscarEconverterObjeto(url);
  }
  async listarDepartamentosPadroes() {
    var url = `${env.url}departamento-padrao`;
    var departamentosPadroes = await super.get(url);

    return departamentosPadroes.map((departamento) => {
        return {
          value: 'P' + departamento.id,
          label: departamento.nome
        };
      });
  }

  async listarHistoricoTimeLine(objetoDeFiltros) {
    const queryString = this.converterObjetoDeFiltrosParaURIEncodedString(objetoDeFiltros);
    return super.get(`${env.url}timeline-tarefas` + queryString);
  }

  async paralisarHistorico(historicoTarefaId, dataContinuacao, faseId = null, isProcesso = false, comentario = '', abortController = this.controladoresDeInstancia.paralisar) {
    try {
      if (!historicoTarefaId || !dataContinuacao) {
        throw {message: `WARN: Não foi possivel paralisar tarefa, histórico ou data de continuação não informados`}
      }
      const url = `${this.url}/paralisar`;

      const dto = {
        historicoTarefaId,
        faseId,
        dataContinuacao,
        isProcesso,
        comentario
      }
      
      const response = await super.post(url, dto, abortController);
      if (!!response?.status && response.status >= parseInt(400)) {
        throw await response.json()
      }

      return response
    } catch (e) {
      console.warn(e)
      throw (e)
    }
  }

  async continuarHistorico(historicoTarefaId, faseId = null, isProcesso = false, abortController = this.controladoresDeInstancia.continuar) {
    try {
      if (!historicoTarefaId) {
        throw `WARN: Não foi possivel continuar tarefa, histórico para continuação não informado`
      }
      const url = `${this.url}/continuar`;

      const dto = {
        historicoTarefaId,
        faseId,
        isProcesso
      }

      return super.post(url, dto, abortController);

    } catch (e) {
      console.warn(e)
    }
  }
  
  async exportarPlanilha(objetoDeFiltros, abortController = this.controladoresDeInstancia.exportarPlanilha) {
    try {
      delete objetoDeFiltros.limit;
      const queryString = this.converterObjetoDeFiltrosParaURIEncodedString(objetoDeFiltros);
      const url = `${this.url}/exportar-tarefas${queryString}`;
      return await super.downloadFile(url, 'application/octet-stream', "Relatorio_de_tarefas.xlsx", abortController);      
    } catch(e) {
      console.warn(e)
      throw new Error("Ocorreu um erro ao exportar a planilha.")
    }
  }
}

export const service = new HistoricoTarefasService()
